{
  "_comment": "[CI-LOCKED] Der Inhalt dieser Datei ist gesperrt. Beiträge sind willkommen, die Änderungsüberprüfung kann jedoch verzögert werden.",
  "ACCESS_KEY_ALT": "ALT UMSCHALT $1",
  "ACCESS_KEY_FOR_MAC_ALT": "CONTROL OPTION $1",
  "ACTIVITY_BOT_SAID_ALT": "Bot $1 sagte:",
  "ACTIVITY_STATUS_VOICE_TRANSCRIPT_AGENT_LABEL": "Agent",
  "ACTIVITY_YOU_SAID_ALT": "Sie sagten:",
  "ACTIVITY_BOT_ATTACHED_ALT": "Bot angefügt:",
  "ACTIVITY_CODE_ALT": "Codebeispiel: $1",
  "ACTIVITY_CONTENT_CAUTION": "KI-generierte Inhalte können falsch sein",
  "ACTIVITY_CODE_CAUTION": "KI-generierter Code. Sorgfältig überprüfen und verwenden",
  "ACTIVITY_ERROR_BOX_TITLE": "Fehlermeldung",
  "ACTIVITY_INTERACTIVE_FOOTNOTE_ALT": "Zum Interagieren klicken.",
  "ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT": "Die Nachricht ist interaktiv.",
  "ACTIVITY_INTERACTIVE_REASON_LINK_ALT": "Die Nachricht enthält mindestens einen Link.",
  "ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT": "Fehler beim Senden.",
  "ACTIVITY_YOU_ATTACHED_ALT": "Sie haben angefügt:",
  "ACTIVITY_NUM_ATTACHMENTS_ONE_ALT": "1 Anhang.",
  "ACTIVITY_NUM_ATTACHMENTS_FEW_ALT": "$1 Anhänge.",
  "ACTIVITY_NUM_ATTACHMENTS_MANY_ALT": "$1 Anhänge.",
  "ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT": "$1 Anhänge.",
  "ACTIVITY_NUM_ATTACHMENTS_TWO_ALT": "$1 Anhänge.",
  "ACTIVITY_STATUS_SEND_FAILED_RETRY": "Fehler beim Senden. [Wiederholen][RETRY].",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING": "Wird gesendet ...",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT": "Gesendet um $1",
  "ACTIVITY_STATUS_TIMESTAMP_JUST_NOW": "Jetzt",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO": "Vor einer Stunde",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO": "Vor einer Minute",
  "ACTIVITY_STATUS_TIMESTAMP_TODAY": "Heute",
  "ACTIVITY_STATUS_TIMESTAMP_YESTERDAY": "Gestern",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE": "Fehler beim Analysieren der adaptiven Karte",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER": "Fehler beim Rendern der adaptiven Karte",
  "ATTACHMENT_AUDIO": "Ein Audioclip.",
  "ATTACHMENT_CARD": "Eine Karte: $1 $2 $3",
  "ATTACHMENT_FILE": "Eine Datei: $1",
  "ATTACHMENT_IMAGE": "Ein Bild",
  "ATTACHMENT_TEXT": "Ein Text: $1",
  "ATTACHMENT_VIDEO": "Ein Videoclip",
  "AVATAR_ALT": "$1-Avatar",
  "CAROUSEL_FLIPPER_NEXT_ALT": "Weiter",
  "CAROUSEL_FLIPPER_PREVIOUS_ALT": "Zurück",
  "CITATION_MODEL_DIALOG_ALT": "Zitat",
  "CLOSE_BUTTON_ALT": "Schließen",
  "COLLAPSIBLE_GROUPING_TITLE": "Denken…",
  "COLLAPSIBLE_GROUPING_TITLE.comment": "Dies wird angezeigt, wenn der Bot Antwortnachrichten in einer Gruppe verfasst, sofern keine Zusammenfassung bereitgestellt wird.",
  "COLLAPSE_BUTTON_LESS": "Weniger anzeigen",
  "COLLAPSE_BUTTON_LESS.comment": "Dies ist der Text einer Chevron-Schaltfläche zum Reduzieren einer Gruppe von Nachrichten. Wenn Endbenutzer auf die Schaltfläche klicken, wird die Gruppe von Nachrichten reduziert.",
  "COLLAPSE_BUTTON_MORE": "Mehr anzeigen",
  "COLLAPSE_BUTTON_MORE.comment": "Dies ist der Text einer Chevron-Schaltfläche zum Erweitern einer Gruppe von Nachrichten. Wenn Endbenutzer auf die Schaltfläche klicken, wird die Gruppe von Nachrichten erweitert.",
  "CONNECTIVITY_STATUS_ALT_CONNECTED": "Verbunden",
  "CONNECTIVITY_STATUS_ALT_CONNECTING": "Verbindung wird hergestellt ...",
  "CONNECTIVITY_STATUS_ALT_FATAL": "Verbindung konnte nicht aufgebaut werden.",
  "CONNECTIVITY_STATUS_ALT_RECONNECTING": "Netzwerkunterbrechung ist aufgetreten. Verbindung wird wiederhergestellt ...",
  "CONNECTIVITY_STATUS_ALT_RENDER_ERROR": "Fehler beim Rendern. Überprüfen Sie die Konsole, oder wenden Sie sich an den Botentwickler.",
  "CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION": "Der Verbindungsvorgang dauert länger als erwartet.",
  "CONNECTIVITY_STATUS_ALT": "Verbindungsstatus: $1",
  "COPY_BUTTON_TEXT": "Kopieren",
  "COPY_BUTTON_COPIED_TEXT": "Kopiert",
  "FEEDBACK_FORM_SUBMIT_BUTTON_LABEL": "Senden",
  "FEEDBACK_FORM_CANCEL_BUTTON_LABEL": "Abbrechen",
  "FEEDBACK_FORM_PLACEHOLDER": "Geben Sie so viele Details wie möglich an, beziehen Sie jedoch weder private noch vertrauliche Informationen ein.",
  "FEEDBACK_FORM_TITLE": "Teilen Sie uns Ihre Erfahrungen mit",
  "FILE_CONTENT_ALT": "„$1“",
  "FILE_CONTENT_DOWNLOADABLE_ALT": "Datei „$1“ herunterladen",
  "FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT": "Datei „$1“ mit einer Größe von $2 herunterladen",
  "FILE_CONTENT_WITH_SIZE_ALT": "„$1“ mit einer Größe von $2",
  "MARKDOWN_EXTERNAL_LINK_ALT": "Wird in einem neuen Fenster geöffnet, extern.",
  "RECEIPT_CARD_TAX": "Steuer",
  "RECEIPT_CARD_TOTAL": "Gesamt",
  "RECEIPT_CARD_VAT": "Umsatzsteuer",
  "REFERENCE_LIST_HEADER_ONE": "$1 Verweis",
  "REFERENCE_LIST_HEADER_FEW": "$1 Verweise",
  "REFERENCE_LIST_HEADER_MANY": "$1 Verweise",
  "REFERENCE_LIST_HEADER_OTHER": "$1 Verweise",
  "REFERENCE_LIST_HEADER_TWO": "$1 Verweise",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_ALT": "Anlage $1 löschen",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_TOOLTIP": "Löschen",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_FILE_ALT": "Eine Datei",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_IMAGE_ALT": "Ein Bild",
  "SEND_BOX_IS_EMPTY_TOOLTIP_ALT": "Eine leere Nachricht kann nicht gesendet werden.",
  "SPEECH_INPUT_LISTENING": "Zuhören ...",
  "SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT": "Mikrofon aus",
  "SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT": "Mikrofon an",
  "SPEECH_INPUT_STARTING": "Wird gestartet ...",
  "SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT": "Weiter",
  "SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT": "Zurück",
  "SUGGESTED_ACTIONS_LABEL_ALT": "Empfohlene Aktionen",
  "TEXT_INPUT_ALT": "Eingabefeld für Nachricht",
  "TEXT_INPUT_PLACEHOLDER": "Nachricht eingeben",
  "TEXT_INPUT_SPEECH_IDLE_PLACEHOLDER": "Beginnen Sie zu sprechen...",
  "TEXT_INPUT_SPEECH_LISTENING_PLACEHOLDER": "Zuhören...",
  "TEXT_INPUT_SPEECH_PROCESSING_PLACEHOLDER": "Wird verarbeitet...",
  "TEXT_INPUT_SPEECH_BOT_SPEAKING_PLACEHOLDER": "Sprechen, um zu unterbrechen...",
  "TEXT_INPUT_SEND_BUTTON_ALT": "Senden",
  "TEXT_INPUT_SPEAK_BUTTON_ALT": "Sprechen",
  "TEXT_INPUT_UPLOAD_BUTTON_ALT": "Datei hochladen",
  "TEXT_INPUT_TELEPHONE_KEYPAD_BUTTON_ALT": "Telefontastatur",
  "TEXT_INPUT_DROP_ZONE": "Dateien ablegen",
  "TEXT_INPUT_LENGTH_EXCEEDED_ALT": "Nachrichtenlänge überschritten",
  "TELEPHONE_KEYPAD_INPUT_MESSAGE": "Unterstützt nur einzelne Eingaben",
  "TEXT_INPUT_ATTACHMENTS_FEW": "$1 Anlagen",
  "TEXT_INPUT_ATTACHMENTS_MANY": "$1 Anlagen",
  "TEXT_INPUT_ATTACHMENTS_ONE": "1 Anlage",
  "TEXT_INPUT_ATTACHMENTS_OTHER": "$1 Anlagen",
  "TEXT_INPUT_ATTACHMENTS_TWO": "$1 Anlagen",
  "TOAST_ACCORDION_FEW": "$1 Benachrichtigungen: Klicken Sie hier, um die Details anzuzeigen.",
  "TOAST_ACCORDION_MANY": "$1 Benachrichtigungen: Klicken Sie hier, um die Details anzuzeigen.",
  "TOAST_ACCORDION_OTHER": "$1 Benachrichtigungen: Klicken Sie hier, um die Details anzuzeigen.",
  "TOAST_ACCORDION_TWO": "$1 Benachrichtigungen: Klicken Sie hier, um die Details anzuzeigen.",
  "TOAST_ALT_ERROR": "Fehler",
  "TOAST_ALT_INFO": "Informationen",
  "TOAST_ALT_SUCCESS": "Erfolg",
  "TOAST_ALT_WARN": "Warnung",
  "TOAST_DISMISS_BUTTON": "Schließen",
  "TOAST_TITLE_ALT": "Benachrichtigung",
  "TRANSCRIPT_ARIA_LABEL_ALT": "Zum Navigieren im Chatverlauf die Pfeiltasten verwenden.",
  "TRANSCRIPT_ARIA_ROLE_ALT": "Chatverlauf",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT": "Die Nachricht ist interaktiv. Drücken Sie 2-3 mal UMSCHALT + TAB-Taste, um in den Chatverlauf zu wechseln. Klicken Sie dann auf die Nachricht, um zu interagieren.",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT": "Die Nachricht enthält mindestens einen Link. Drücken Sie 2-3 mal UMSCHALT + TAB-Taste, um in den Chatverlauf zu wechseln. Klicken Sie dann auf die Nachricht, um zu interagieren.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT": "In der Nachricht sind Aktionen vorgeschlagen worden. Drücken Sie die UMSCHALT + TAB-Taste 2 bis 3 Mal, um sie auszuwählen.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT": "In der Nachricht sind Aktionen vorgeschlagen worden. Drücken Sie $1, um sie auszuwählen.",
  "TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT": "Fehler beim Senden der Nachricht.",
  "TRANSCRIPT_LIVE_REGION_NEW_MESSAGES_ALT": "Neue Nachrichten verfügbar. Drücken Sie $1, um die Schaltfläche „$2“ zu fokussieren.",
  "TRANSCRIPT_MORE_MESSAGES": "Weitere Meldungen",
  "TRANSCRIPT_NEW_MESSAGES": "Neue Nachrichten",
  "TRANSCRIPT_TERMINATOR_TEXT": "Ende des Chatverlaufs",
  "TYPING_INDICATOR_ALT": "Anzeigen des Eingabeindikators",
  "TYPING_INDICATOR_SINGLE_TEXT": "$1 gibt gerade ein.",
  "TYPING_INDICATOR_MULTIPLE_TEXT": "$1 und weitere geben gerade ein.",
  "VIEW_CODE_BUTTON_TEXT": "Code",
  "VOTE_COMPLETE_ALT": "Feedback aufgezeichnet",
  "VOTE_COMPLETE_ALT.comment": "Dies ist für die Sprachausgabe vorgesehen. Die Beschriftung einer Schaltfläche mit Daumen-hoch-/runter-Symbol. Die Beschriftung wird verwendet, wenn Feedback aufgezeichnet wurde.",
  "VOTE_DISLIKE_ALT": "Mit „Gefällt mir nicht“ markieren",
  "VOTE_LIKE_ALT": "Mit „Gefällt mir“ markieren"
}